<template>
  <div class="overflow-x-auto bg-base-200 p-4 rounded-lg shadow-sm">
    <table class="w-full text-sm border-collapse">
      <thead>
        <tr>
          <th
            v-for="(_, index) in headers"
            :key="index"
            :class="[
              'px-4 py-2 text-gray-700 font-semibold uppercase tracking-wider',
              alignClass(alignments?.[index] || 'left'),
              'bg-base-300',
            ]"
          >
            {{ t(`cookie.functionalCookiesTable.headers[${index}]`) }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(_, rowIndex) in rows"
          :key="rowIndex"
          :class="rowIndex % 2 === 0 ? 'bg-base-100' : 'bg-base-200'"
        >
          <td
            v-for="(_, colIndex) in headers"
            :key="colIndex"
            :class="[
              'px-4 py-3 text-gray-700',
              alignClass(alignments?.[colIndex] || 'left'),
            ]"
          >
            {{
              t(`cookie.functionalCookiesTable.rows[${rowIndex}][${colIndex}]`)
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

defineProps<{
  headers: any[]; // Just indexes now
  rows: any[];
  alignments?: ("left" | "center" | "right")[];
}>();

const { t } = useI18n();

const alignClass = (align: "left" | "center" | "right") => {
  switch (align) {
    case "center":
      return "text-center";
    case "right":
      return "text-right";
    case "left":
    default:
      return "text-left";
  }
};
</script>
